import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, Card, CardContent, Checkbox, Grid, MenuItem, TextField, Typography, FormControlLabel } from '@mui/material';

import { token, apiUrl } from '../../../api';
import api from '../../services/api';

const API_BASE = process.env.REACT_APP_BACKEND_SERVER || 'http://127.0.0.1:9000';

const CriaPipeline = ({ onClose }) => {
    const [status, setStatus] = useState({ type: '', message: '' });
    const [listaPipelines, setListaPipelines] = useState([]);
    const [selecionouCriarPipeline, setSelecionouCriarPipeline] = useState(false);
    const [namePipeline, setNamePipeline] = useState('');
    const [pipelineSelecionada, setPipelineSelecionada] = useState(null);
    const [reloadPipelines, setReloadPipelines] = useState(false);
    const [appId, setAppId] = useState(null);

    //  pegar app padrão
    const pegar_app_padrao = async () => {
        try {
            const response = await api.get('v1/apps/default/');
            setAppId(response.data.app.id);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        pegar_app_padrao();
    }, []);

    //  só busca user quando tiver appId
    useEffect(() => {
        carregarPipelines();
    }, [appId]);

    const handleVoltar = () => {
        setSelecionouCriarPipeline(false);
        setSelecionouCriarPipeline(false);
        setPipelineSelecionada(false);
    };

    useEffect(() => {
        carregarPipelines();
    }, [appId, reloadPipelines]);

    const carregarPipelines = async () => {
        if (!appId) return;

        try {
            const myHeaders = new Headers();
            myHeaders.append('Content-Type', 'application/json');

            const response = await api.get(`v1/apps/${appId}/pipelines/`);
            const dados = response.data;
            console.log('postMessage - dados recebidos:', dados);

            // ajuste conforme o formato da sua API
            if (!dados || !Array.isArray(dados)) {
                return;
            }
            setListaPipelines(dados);
        } catch (error) {
            setStatus({
                type: 'error',
                message: error.response?.data?.detail || 'Erro ao carregar pipelines.'
            });
            console.error('Erro ao criar app:', error.response?.data || error);
        }
    };

    const criarPipeline = async () => {
        try {
            if (!appId) return;

            const myHeaders = new Headers();
            myHeaders.append('Content-Type', 'application/json');

            console.log(`criarPipeline - v1/apps/${appId}/pipelines/`);

            const response = await api.post(`v1/apps/${appId}/pipelines/`, {
                name: namePipeline
            });
            if (response.data) {
                setStatus({ type: 'success', message: 'Pipeline criada com sucesso!' });
                handleVoltar();
                setReloadPipelines();
                console.log('Pipelines carregados:', response.data);
            } else {
                setStatus({
                    type: 'error',
                    message: 'Erro ao criar Pipeline.'
                });
            }
            // const dados = response.data;
        } catch (error) {
            setStatus({
                type: 'error',
                message: error.response?.data?.detail || 'Erro ao criar Pipeline.'
            });
            console.error('Erro ao criar app:', error.response?.data || error);
        }
    };

    const deletarPipeline = async () => {
        try {
            if (!appId) return;

            const myHeaders = new Headers();
            myHeaders.append('Content-Type', 'application/json');

            const response = await api.delete(`v1/apps/${appId}/pipelines/${pipelineSelecionada.id}/`);

            setStatus({ type: 'success', message: 'Pipeline Deletada com sucesso!' });
            setReloadPipelines(true);
            console.log('Retorno deletar pipeline', response.data);
        } catch (error) {
            setStatus({
                type: 'error',
                message: error.response?.data?.detail || 'Erro ao deletar Pipeline.'
            });
            console.error('Erro ao criar app:', error.response?.data || error);
        }
    };

    return (
        <>
            <Typography variant="h2" sx={{ mb: 2, marginTop: 3, marginLeft: 2 }}>
                Pipelines do Negócio
            </Typography>

            {status.message && (
                <Alert severity={status.type} sx={{ mb: 2 }}>
                    {status.message}
                </Alert>
            )}

            {!selecionouCriarPipeline && !pipelineSelecionada && (
                <CardContent>
                    {/* Cabeçalho */}
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: '230px 100px 200px 250px',
                            fontWeight: 'bold',
                            pb: 1,
                            borderBottom: '2px solid #eee'
                            // marginTop: 3
                        }}
                    >
                        {/* <Typography variant="h4">ID</Typography> */}
                        <Typography variant="h4">Nome</Typography>
                    </Box>

                    {/* Linhas da tabela */}
                    {listaPipelines.map((pipeline) => (
                        <Box
                            key={pipeline.id}
                            sx={{
                                display: 'grid',
                                gridTemplateColumns: '230px 100px 200px 250px',
                                borderBottom: '1px solid #f0f0f0',
                                py: 1,
                                alignItems: 'center',
                                cursor: 'pointer'
                            }}
                            onClick={(e) => {
                                console.log('clicou na pipeline:', pipeline);
                                setPipelineSelecionada(pipeline);
                                // setOpenInfoApp(true);
                                // setDetalhesApp(app);
                                // if (e.target.tagName !== 'INPUT' && !e.target.dataset.org) {
                                //     handleOpenUser(user);
                                // }
                            }}
                        >
                            {/* Nome */}
                            {/* <Typography>{pipeline.id}</Typography> */}
                            {/* Nome */}
                            <Typography>{pipeline.name}</Typography>
                        </Box>
                    ))}
                    <Button variant="contained" sx={{ mr: 1, mt: 3, backgroundColor: '#32CD32' }} onClick={setSelecionouCriarPipeline}>
                        Adicionar Pipeline
                    </Button>
                </CardContent>
            )}

            {selecionouCriarPipeline && (
                <>
                    {status.message && (
                        <Alert severity={status.type} sx={{ mb: 2 }}>
                            {status.message}
                        </Alert>
                    )}
                    <Typography variant="h5" marginTop={3}>
                        Adicionar Pipeline
                    </Typography>
                    <TextField
                        label="Nome da Pipeline"
                        fullWidth
                        margin="normal"
                        value={namePipeline}
                        onChange={(e) => setNamePipeline(e.target.value)}
                    />
                    <Button variant="contained" sx={{ mr: 1, mt: 3, backgroundColor: '#32CD32' }} onClick={criarPipeline}>
                        Criar Pipeline
                    </Button>
                </>
            )}

            {pipelineSelecionada && !selecionouCriarPipeline && (
                <>
                    {status.message && (
                        <Alert severity={status.type} sx={{ mb: 2 }}>
                            {status.message}
                        </Alert>
                    )}
                    <Typography variant="h5" marginTop={3}>
                        Nome: {pipelineSelecionada.name}
                    </Typography>

                    <Button variant="outlined" sx={{ mr: 1, mt: 3, backgroundColor: '#32CD32' }} color="secondary" onClick={handleVoltar}>
                        Voltar
                    </Button>

                    <Button
                        variant="outlined"
                        sx={{ mr: 1, mt: 3, backgroundColor: '#dba08a' }}
                        color="secondary"
                        onClick={deletarPipeline}
                    >
                        Apagar Pipeline
                    </Button>
                </>
            )}
        </>
    );
};

export default CriaPipeline;
